import { render } from "./MovieSection.vue?vue&type=template&id=6fcf4004"
import script from "./MovieSection.vue?vue&type=script&lang=js"
export * from "./MovieSection.vue?vue&type=script&lang=js"

import "./MovieSection.vue?vue&type=style&index=0&id=6fcf4004&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__